const ToastTemplateDefault = ({ message }) => message;

export default ToastTemplateDefault;
